export enum FilterSectionType {
    RESOURCE = "resource",
    CHANGE = "change",
    ACTOR = "actor",
}
